
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/gitlab",
      function () {
        return require("private-next-pages/services/gitlab/index.tsx");
      }
    ]);
  